export class PackageLookupToken {
  static IPackageLookupRepository = Symbol("IPackageLookupRepository");
  static PackageLookupUseCase = Symbol("PackageLookupUseCase");
  static PackageLookupViewModel = Symbol("PackageLookupViewModel");
}
